module.exports = __webpack_public_path__ + "static/media/image-4x3.d7c90456.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/image-4x3.png
// module id = 348
// module chunks = 0